import React from 'react';

interface MaterialIconProps {
  className?: string;
  isActive?: boolean;
  size?: number;
}

export const MaterialIcon: React.FC<MaterialIconProps> = ({ 
  className = '', 
  isActive = false, 
  size = 18 
}) => {
  const colorClasses = isActive 
    ? 'text-[#72A8FD] group-hover:text-[#8BB8FE]' 
    : 'text-white group-hover:text-gray-200';

  return (
    <svg 
      width={size} 
      height={size * 1.17} // Maintain aspect ratio (18:21)
      viewBox="0 0 18 21" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={`${colorClasses} transition-colors duration-200 ${className}`}
    >
      <path 
        d="M1.8 3.5V19.25H16.2V21H1.8C0.81 21 0 20.2125 0 19.25V3.5H1.8ZM11.7 6.125H16.65L11.7 1.3125V6.125ZM5.4 0H12.6L18 5.25V15.75C18 16.7213 17.199 17.5 16.2 17.5H5.4C4.401 17.5 3.6 16.7125 3.6 15.75V1.75C3.6 0.77875 4.401 0 5.4 0ZM13.5 14V12.25H5.4V14H13.5ZM16.2 10.5V8.75H5.4V10.5H16.2Z" 
        fill="currentColor"
      />
    </svg>
  );
}; 